<template>
<div class="fit column items-center justify-center">
  <div>
    <div class="bg-riseup-yellow commission-discount">
      <span class="text-riseup-black small r-text-bold">הנחה בדמי ניהול!</span>
    </div>
  </div>
  <div class="commission text-riseup-white">{{ COMMISSION_IN_PERCENTAGE }}%</div>
</div>
</template>

<script>
import { COMMISSION_IN_PERCENTAGE } from '@/constants/meitav-dash/open-fund';

export default {
  name: 'CommissionSlide',
  computed: {
    COMMISSION_IN_PERCENTAGE() {
      return COMMISSION_IN_PERCENTAGE;
    },
  },
};
</script>

<style lang="scss" scoped>

.commission {
  font-family: SimplerPro_Alte-Black;
  font-size: 85px;
  line-height: 1;
}

.commission-discount {
  display: inline-block;
  padding: 2px 8px;
  transform: translateX(-85px) translateY(15px) rotate(-27deg) ;
}

</style>
